import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import './autosuggestGEO.css';
import { connect } from "react-redux";
import { searchCityByTerm, searchCountyByTerm } from '../../../SHARED/actions/geolocation.actions';

const renderSuggestion = suggestion => {

    return (
        <div className="suggestion">
            { suggestion }
        </div>
    );
};

class AutosuggestGEO extends Component {
    constructor() {
        super();

        this.state = {
            value: '',
            suggestions: []
        };
    }

    componentWillReceiveProps(nextProps){
        const val = nextProps.value ? nextProps.value : '';
        this.setState({value: val});
    }

    getSuggestionValue = suggestion => {
        return suggestion;
        //this.clickItem(suggestion);
        //return ''; //we need to erase the input field value once it has been clicked
    };

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
    };

    clickItem = (data) => {
        //this.props.addCity(data);
    };

    onSuggestionsFetchRequested = term => {
        //make api request
        if(this.props.field === 'cities') {
            this.props.searchCityByTerm(term.value);
        } else {
            this.props.searchCountyByTerm(term.value);
        }

    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    render() {
        const { value } = this.state;
        const placeholderInput = this.props.field === 'locality' ? 'Oras' : 'Judet';

        const inputProps = {
            name: this.props.field,
            placeholder: placeholderInput,
            value,
            onChange: this.onChange
        };

        return (
            <div className="control">
                <Autosuggest
                    suggestions={this.props.field === 'locality' ? this.props.cities : this.props.counties}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSuggestionValue={this.getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    inputProps={inputProps}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    cities: state.geolocation.cities,
    counties: state.geolocation.counties
});
export default connect(mapStateToProps, {searchCityByTerm, searchCountyByTerm})(AutosuggestGEO);



// WEBPACK FOOTER //
// ./src/SHARED/components/autosuggest/autosuggest.component.js